"use client";

import { c as _c } from "react/compiler-runtime";
import { StytchB2BProvider } from "@stytch/nextjs/b2b";
import { createStytchB2BHeadlessClient } from "@stytch/nextjs/b2b/headless";
import { QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren } from "react";
import { isAlternateHost } from "@/src/lib/alternate-host";
import { queryClient } from "@/src/query/query-client";
const stytchOptions = {
  cookieOptions: {
    availableToSubdomains: true,
    domain: "valeriehealth.com"
  }
};

// On preview and GKE hosts (not registered Stytch SDK domains), route SDK calls through the
// same-origin /sdk/v1 proxy so they reach Stytch with a registered Origin.
const proxiedSdkHost = typeof window !== "undefined" && isAlternateHost(window.location.host) ? window.location.host : null;
const stytch = createStytchB2BHeadlessClient(process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN || "", {
  ...stytchOptions,
  ...(proxiedSdkHost ? {
    customBaseUrl: proxiedSdkHost
  } : {})
});
export function RootProviders(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <StytchB2BProvider stytch={stytch}><QueryClientProvider client={queryClient}>{children}</QueryClientProvider></StytchB2BProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}